<template>

  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="系统信息"><el-input size="small" v-model="formInline.keyword" placeholder="请输入系统名称或ID"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loaded">
            <el-table-column prop="app_id" label="ID" width="100"></el-table-column>
            <el-table-column prop="app_name" label="系统名称"></el-table-column>
            <el-table-column fixed="right" label="操作" >
              <template slot-scope="scope">

                <el-button @click="copyData(scope.row)" type="text" size="small">一键复制</el-button>
                <el-button @click="openPopup(scope.row,'system')" type="text" size="small">系统链接</el-button>


              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--页面链接-->
    <LinkPage v-if="show_path" :is_open="show_path" :path_type="path_type" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'path')"></LinkPage>
  </div>
</template>
<script>
  import Datashare from '@/api/datashare.js';
  import LinkPage from '@/components/page/path';
  export default {
    components: {
      LinkPage
    },
    data() {
      return {
        formLabelWidth:'100px',
        formInline: {
          keyword:''
        },
        form: {},
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*是否加载完成*/
        loaded: true,
        dataModel:'',
        show_path:false,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      copyData(item){
          const loading = this.$loading({
            lock: true,
            text: '数据复制中请等待',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        Datashare.copy({app_id:item.app_id}, true)
          .then(res => {
            console.log(res);
            setTimeout(() => {
              loading.close();
              this.$message.success("复制成功！");
            }, 2000);
          })
          .catch(error => {
            setTimeout(() => {
              loading.close();
              this.$message.success("操作失败！");
            }, 2000);
          });
        
      },
       /*复制*/
      submitCopy(value='') {
        var copyContent = document.createElement('input');     //创建一个隐藏input（重要！）
        copyContent.value = value
        document.body.appendChild(copyContent);
        copyContent.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message.success("复制成功！");
        copyContent.remove();
      },
      /*关闭弹窗*/
    closeDialogFunc(e, f) {
        this.show_path = e.openDialog;
    },
       openPopup(item,type){
        // let baseUrl = window.location.protocol + '//' + window.location.host;
        // item.wap_url = baseUrl+'?app_id='+item.app_id+'/#/pages/index/homePage';
        // this.dataModel = item;
        // this.show_path = true;

        this.dataModel = item;
        this.show_path = true;
        this.path_type = type;
      },
      onSubmit(){
        let self = this;
        self.curPage = 1;
        self.getData()
      },
      /*获取列表*/
      getData() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Datashare.getList(Params, true)
          .then(res => {
            self.loaded = false;
            self.tableData = res.data.data;
            self.totalDataNumber = res.data.total
          })
          .catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loaded = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
     

    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/datashare/shop/index.vue